import React from 'react'
import { NaviGate } from "../../../Utility/function";
import { useNavigate } from "react-router-dom";

const Product = () => {
    const navigate = useNavigate();
    let menuItems = [
        {
            name: "Category",
            route: "/Category_list",
            icon: "bi bi-tags",
            url: "assets/images/menu/category.png",
        },
        // {
        //     name: "Subcategory",
        //     route: "/Subcategory_list",
        //     icon: "bi bi-tag",
        //     url: "assets/images/menu/subcat.png",
        // },
        {
            name: "Product Master ",
            route: "/product_master",
            icon: "bi bi-tag",
            url: "assets/images/menu/product.png",
        },
        {
            name: "Products",
            route: "/Product_master_details",
            icon: "bi bi-bag-check",
            url: "assets/images/menu/product.png",
        },

        // {
        //     name: "Raw Materials",
        //     route: "/raw_materials",
        //     icon: "bi bi-tag",
        //     url: "assets/images/menu/subcat.png",
        // },
        // {
        //     name: "End Products",
        //     route: "/e_product",
        //     icon: "bi bi-tag",
        //     url: "assets/images/menu/subcat.png",
        // },
        // {   name: "RMP Transection",
        //     route: "/raw_transection",
        //     icon: "bi bi-tag",
        //     url: "assets/images/menu/subcat.png",
        // },


        // {
        //     name: "End Product ingridents",
        //     route: "/ingridents",
        //     icon: "bi bi-tag",
        //     url: "assets/images/menu/product.png",
        // },
        {
            name: "Product Process",
            route: "/e_product_process",
            icon: "bi bi-tag",
            url: "assets/images/menu/product.png",
        },
        // {
        //     name: " Product Transection",
        //     route: "/e_product",
        //     icon: "bi bi-tag",
        //     url: "assets/images/menu/product.png",
        // },
        {
            name: " Product Detail Transection",
            route: "/product-detail-transaction",
            icon: "bi bi-tag",
            url: "assets/images/menu/product.png",
        },
        {
            name: "Products Expire",
            route: "/product_expire",
            icon: "bi bi-tag",
            url: "assets/images/menu/product.png",
        },
        // {
        //     name: "Product Quantity",
        //     route: "/ProductQty_list",
        //     icon: "bi bi-boxes",
        //     url: "assets/images/menu/productQty.png",
        // },
        // {
        //     name: "Product Expiry",
        //     route: "/product_expiry",
        //     icon: "bi bi-currency-exchange",
        //     url: "assets/images/menu/finace.png",
        // },
        // {
        //     name: "Bar Code",
        //     route: "/bar_code",
        //     icon: "bi bi-people",
        //     url: "assets/images/menu/user.png",
        // },
    ]
    const handleCardClick = (route) => {
        navigate(route);
    };
    return (
        <div className="my-4 mx-3 pb-5 ">
            <NaviGate />
            <div className="product-grid row  d-flex justify-content-center align-items-center" style={{ padding: "10 25px", minHeight: "80vh", }}>
                {menuItems
                    .map((item, index) => (
                        <div className="col-12 col-md-4 col-lg-2 mb-2 mt-2 " key={index}>
                            <div
                                className="card h-100 text-center"
                                onClick={() => handleCardClick(item.route)}
                                style={{ cursor: "pointer" }}
                            >
                                <div className="card-body ">
                                    <img
                                        src={item?.url}
                                        width={"50px"}
                                        style={{ marginTop: "8px" }}
                                        alt={item.name}
                                    />
                                    <h5 className="card-title mt-3 text-small">{item.name}</h5>
                                </div>
                            </div>
                        </div>
                    ))}
            </div>
        </div>
    )
}

export default Product
